export enum ENotesUrls {
  NOTES = 'notes',
}
